import { Box, IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import './Loads.scss';
import constants from '../../../../../utils/constants';
import CustomIconButton from '../../../../../common/components/buttons/CustomIconButton';
import { useForm } from 'react-hook-form';
import { Icon } from '@iconify/react';
import CustomDataGrid from '../../../../../common/components/customized/customdatagrid/CustomDataGrid';
import CustomDeletePopup from '../../../../../common/components/customdelete/CustomDeletePopup';
import CustomActivatePopup from '../../../../../common/components/customactive/CustomActivatePopup';
import CustomButton from '../../../../../common/components/buttons/CustomButton';
import AddLoad from './AddLoads';
import { GridCellProps } from '@mui/x-data-grid';
import { useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../app/redux/hooks';
import {
  deactiveLoads,
  deleteLoads,
  freightNames,
  getActiveNames,
  getLoads
} from '../../../redux/reducer/truckManagementSlices/loadsSlice';
import {
  convertEpochToDateandTime,
  useAbort,
  usePagination
} from '../../../../../utils/commonFunctions';
import { updateIsShowMap } from '../../../../yaantrac/redux/reducer/yaantracSlices/reportSlice';
import CustomDialog from '../../../../../common/components/customdialog/CustomDialog';
import Actions from '../../../../../common/pages/user/management/components/reports/Actions';
import CustomBreadcrumbs from '../../../../../common/components/custombreadcrumbs/CustomBreadcrumbs';
import CustomDialogList from '../../../../../common/components/customdialoglist/CustomDialogList';
import CustomSearch from '../../../../../common/components/customized/customsearch/CustomSearch';
import { Any } from 'react-spring';

interface PaginationModel {
  page: number;
  pageSize: number;
}

const Loads = () => {
  const [type, setType] = useState<string>('Add Loads');
  const [open, setOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const [isActivate, setIsActivate] = useState<boolean>(false);
  const [filteredRow, setFilteredRow] = useState<any>(null);
  const [view, setView] = useState<boolean>(false);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [viewFreight, setViewFreight] = useState<boolean>(false);
  const [Freightdata, setFreightdata] = useState<any>(false);
  const [loads, setLoads] = useState([]);
  const [isViewData, setIsViewData] = useState<any>([]);
  const [sortModel, setSortModel] = useState<any>([]);
  const [inputValue, setInputValue] = useState<any>('');
  const [index, setIndex] = useState(0);
  const { pageSize, pageNo, pagination, setPageNo, setPageSize } = usePagination();
  const [tablePayload, setTablePayload] = useState({
    pageNo: 1,
    pageSize: 5,
    sortColumnName: null,
    sortBy: null,
    searchInput: null,
    searchColumnName: null
  });
  const intervalId = useRef<NodeJS.Timeout | null>(null);
  const createabort = useAbort();

  const { data, isLoading, count } = useAppSelector(state => state?.loads);
  const { isLoading: deactivateLoading } = useAppSelector(
    state => state?.deactivateLoads
  );
  const { isLoading: deleteLoading } = useAppSelector(state => state?.deleteAllLoads);
  const { isShowMap, Polyline, Waypoints } = useAppSelector(state => state.reportDialog);
  const dispatch = useAppDispatch();

  const { control } = useForm();

  const isOpen = Boolean(anchorEl);

  const placeholderText = [
    'Search for Load Number',
    'Search for Load Type',
    'Search for Truck Load Type',
    'Search for Customer ID',
    'Search for Freight Number'
  ];

  const dynamicOptions = [
    {
      id: `${inputValue}`,
      label: `Load Number :${inputValue}`,
      columnName: 'loadNumber'
    },
    {
      id: `${inputValue}`,
      label: `Load Type :${inputValue}`,
      columnName: 'loadType'
    },
    {
      id: `${inputValue}`,
      label: `Truck Load :${inputValue}`,
      columnName: 'truckLoadType'
    },
    {
      id: `${inputValue}`,
      label: `Customer ID :${inputValue}`,
      columnName: 'customerId'
    },
    {
      id: `${inputValue}`,
      label: `Freight Number :${inputValue}`,
      columnName: 'frieghtNumber'
    }
  ];

  const stackeholdernames = filteredRow?.stackholder?.map(
    (value: any, index: number) => ({
      id: index + 1,
      shipperId: value.shipperId,
      consigneeId: value.consigneeId,
      pickUpDate: convertEpochToDateandTime(value.pickUpDate),
      deliveryDate: convertEpochToDateandTime(value.deliveryDate),
      pickUpAddress: value.pickUpAddress,
      deliveryAddress: value.deliveryAddress,
      pickupInstructions: value?.pickupInstructions,
      deliveryInstructions: value?.deliveryInstructions,
      pickUpLatitude: value?.pickUpLatitude,
      pickUpLongitude: value?.pickUpLongitude,
      startLat: value?.pickUpLatitude,
      startLng: value?.pickUpLongitude,
      endLat: value?.deliveryLatitude,
      endLng: value?.deliveryLongitude,
      type: 'Load'
    })
  );

  let columnsView = [
    {
      field: 'id',
      headerName: `Id`,
      flex: 1,
      minWidth: 100
    },
    {
      field: 'shipperId',
      headerName: `Shipper`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'consigneeId',
      headerName: `Consignee`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'pickUpDate',
      headerName: `Pickup Date`,
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) => (
        <Tooltip color='primary' placement='bottom' title={params?.row?.pickUpDate} arrow>
          {params?.row?.pickUpDate}
        </Tooltip>
      )
    },
    {
      field: 'deliveryDate',
      headerName: `Delivery Date`,
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) => (
        <Tooltip
          color='primary'
          placement='bottom'
          title={params?.row?.deliveryDate}
          arrow
        >
          {params?.row?.deliveryDate}
        </Tooltip>
      )
    },
    {
      field: 'pickUpAddress',
      headerName: `Pickup Location`,
      flex: 1,
      minWidth: 150,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => Actions(params)
    },
    {
      field: 'deliveryAddress',
      headerName: `Delivery Location`,
      flex: 1,
      minWidth: 150,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => Actions(params)
    },
    {
      field: 'pickupInstructions',
      headerName: `Pickup Instructions`,
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) => (
        <Tooltip
          color='primary'
          placement='bottom'
          title={params?.row?.pickupInstructions}
          arrow
        >
          {params?.row?.pickupInstructions}
        </Tooltip>
      )
    },
    {
      field: 'deliveryInstructions',
      headerName: `Delivery Instructions`,
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) => (
        <Tooltip
          color='primary'
          placement='bottom'
          title={params?.row?.deliveryInstructions}
          arrow
        >
          {params?.row?.deliveryInstructions}
        </Tooltip>
      )
    }
  ];

  let columns = [
    {
      field: 'isActive',
      headerName: `Status`,
      flex: 1,
      minWidth: 100,
      renderCell: ({ value }: GridCellProps) =>
        value === 1 ? (
          <Icon icon='carbon:circle-filled' style={{ color: '#0EBC93' }} />
        ) : (
          <Icon icon='carbon:circle-filled' style={{ color: '#FF2532' }} />
        )
    },
    /*  {
      field: 'id',
      headerName: `Id`,
      flex: 1,
      minWidth: 100
    }, */
    {
      field: 'loadNumber',
      headerName: `Load Number`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'loadType',
      headerName: `Load Type`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'truckLoadType',
      headerName: `Truck Load`,
      flex: 1,
      minWidth: 150
    },

    {
      field: 'customerId',
      headerName: `Customer ID`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'customerAddress',
      headerName: `Customer Address`,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      minWidth: 150,
      renderCell: (params: any) => Actions(params)
    },
    /*  {
      field: 'description',
      headerName: `Reference`,
      flex: 1,
      minWidth: 150
    }, */
    {
      field: 'freightNumbers',
      headerName: `Freight Number`,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) =>
        params?.row.freightNumbers.length > 0 ? (
          <Box>
            <CustomIconButton
              category='View'
              showTooltip={false}
              onClick={() => handleViewFreight(params)}
            />{' '}
            {''}
          </Box>
        ) : (
          'NA'
        )
    },
    /*  {
      field: 'description',
      headerName: `Description`,
      flex: 1,
      minWidth: 150
    },
 */
    {
      field: 'weight',
      headerName: `Weight`,
      flex: 1,
      minWidth: 100,
      renderCell: ({ row }: any) => {
        return String(row.weight).concat(' ', row.weightUnit);
      }
    },
    {
      field: 'length',
      headerName: `Length`,
      flex: 1,
      minWidth: 100,
      renderCell: ({ row }: any) => {
        return String(row.length).concat(' ', row.dimensionUnit);
      }
    },
    {
      field: 'width',
      headerName: `Width`,
      flex: 1,
      minWidth: 100,
      renderCell: ({ row }: any) => {
        return String(row.width).concat(' ', row.dimensionUnit);
      }
    },
    {
      field: 'height',
      headerName: `Height`,
      flex: 1,
      minWidth: 100,
      renderCell: ({ row }: any) => {
        return String(row.height).concat(' ', row.dimensionUnit);
      }
    },
    {
      field: 'totalCost',
      headerName: `Total Cost`,
      flex: 1,
      minWidth: 100
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      minWidth: 150,
      renderCell: ({ row }: any) => (
        <Box>
          <Tooltip title='Menu' placement='right' arrow>
            <IconButton
              id='basic-button'
              sx={{ display: 'flex', justifyContent: 'flex-start', pl: 0 }}
              aria-controls={isOpen ? 'basic-menu' : undefined}
              aria-haspopup='true'
              aria-expanded={isOpen ? 'true' : undefined}
              onClick={event => {
                setType(`Update Load`);
                /*  handleUpdate(row); */
                setFilteredRow(row);
                setAnchorEl(event.currentTarget);
              }}
            >
              <Icon icon='eva:menu-2-outline' className='white-bg' />
            </IconButton>
          </Tooltip>
          <Menu anchorEl={anchorEl} open={isOpen} onClose={handleClose}>
            <MenuItem disabled={filteredRow?.isActive === 0} onClick={handleViewLoad}>
              <CustomIconButton category='View' showTooltip={false} /> {''}
              {constants.View}
            </MenuItem>
            <MenuItem
              disabled={filteredRow?.isActive === 0}
              onClick={() => {
                setIsUpdate(true);
                setOpen(true);
                handleClose();
              }}
            >
              <CustomIconButton category='Update' showTooltip={false} /> {''}
              {constants.Update}
            </MenuItem>
            <MenuItem
              onClick={() => {
                setIsActivate(true);
                handleClose();
              }}
            >
              {filteredRow?.isActive === 0 ? (
                <CustomIconButton showTooltip={false} category='Active' />
              ) : (
                <CustomIconButton showTooltip={false} category='Deactive' />
              )}

              {filteredRow?.isActive === 0 ? constants.ActiveStatus : constants.Deactive}
            </MenuItem>
            <MenuItem
              disabled={filteredRow?.isActive === 0}
              onClick={() => {
                setIsDelete(true);
                setMessage(`${constants.DeleteCustomer} Load?`);
                handleClose();
              }}
            >
              <CustomIconButton category='Delete' showTooltip={false} /> {''}
              {constants.Delete}
            </MenuItem>
          </Menu>
        </Box>
      )
    }
  ];

  // function to close
  const handleClose = () => {
    setAnchorEl(null);
  };

  // function for filter Search
  const handleSearchColumnChange = async (event: any, newValue: any) => {
    const payload = {
      ...tablePayload,
      searchColumnName: newValue?.columnName,
      searchInput: newValue?.id
    };
    setTablePayload(payload);
    await dispatch(getLoads({ ...payload, signal: createabort().abortCall.signal }));
    setPageNo(1);
    setPageSize(5);
  };

  // function for normal search
  const handleSearch = async () => {
    const payload = {
      ...tablePayload,
      searchInput: inputValue
    };
    setTablePayload(payload);
    await dispatch(getLoads({ ...payload, signal: createabort().abortCall.signal }));
    setPageNo(1);
    setPageSize(5);
  };

  // function for dynamic options
  const handleInputChange = async (event: any, newValue: string) => {
    const payload: any = {
      ...tablePayload,
      searchInput: newValue
    };
    if (!newValue) {
      await dispatch(getLoads({ ...payload, signal: createabort().abortCall.signal }));
    }
    setInputValue(newValue);
    setTablePayload(payload);
    setPageNo(1);
    setPageSize(5);
  };

  // Function to stop the interval
  const stopInterval = () => {
    if (intervalId.current) {
      clearInterval(intervalId.current);
      intervalId.current = null;
    }
  };

  // handle start interval
  const startInterval = () => {
    intervalId.current = setInterval(() => {
      setIndex(prevIndex => {
        return prevIndex === placeholderText.length - 1 ? 0 : prevIndex + 1;
      });
      if (inputValue.length > 0) {
        stopInterval();
      }
    }, 2000);
  };

  const handleDelete = async () => {
    if (filteredRow?.id) {
      let action1 = await dispatch(deleteLoads(filteredRow?.id));
      if (deleteLoads.fulfilled.match(action1)) {
        setPageNo(1);
        setPageSize(5);
        await dispatch(
          getLoads({
            pageNo: 1,
            pageSize: 5
          })
        );
      }
    }
    setIsDelete(false);
  };

  const handleDeactivate = async () => {
    if (filteredRow?.id) {
      const action1 = await dispatch(deactiveLoads(filteredRow?.id));
      if (deactiveLoads.fulfilled.match(action1)) {
        setPageNo(1);
        setPageSize(5);
        await dispatch(
          getLoads({
            pageNo: 1,
            pageSize: 5
          })
        );
      }
    }
    setIsActivate(false);
  };

  const handleViewLoad = async (params: any) => {
    setView(true);
    handleClose();
    setIsViewData(filteredRow);
    setDialogOpen(true);
  };

  const handleViewFreight = (params: any) => {
    setFreightdata(params?.row?.freightNumbers ? params?.row?.freightNumbers : ['NA']);
    setViewFreight(true);
  };

  const handleViewClose = () => {
    setView(false);
    setViewFreight(false);
    setDialogOpen(false);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setViewFreight(false);
  };

  const handlePagination = async (newPaginationModel: PaginationModel) => {
    if (sortModel.length > 0) {
      await dispatch(
        getLoads({
          ...pagination(newPaginationModel),
          ...(sortModel?.length > 0
            ? { sortBy: sortModel[0].sort, sortColumnName: sortModel[0].field }
            : []),
          signal: createabort().abortCall.signal
        })
      );
    } else {
      await dispatch(
        getLoads({
          ...pagination(newPaginationModel),
          signal: createabort().abortCall.signal
        })
      );
    }
  };

  const handleSortModelChange = async (model: any) => {
    setSortModel(model);
    const payload = {
      ...tablePayload,
      sortColumnName: (model.length > 0 && model[0].field) || null,
      sortBy: (model.length > 0 && model[0].sort.toUpperCase()) || null
    };
    setTablePayload(payload);
    await dispatch(getLoads({ ...payload, signal: createabort().abortCall.signal }));
  };

  const handleSelect = () => {
    setFilteredRow(null);
    setType('Add Loads');
    setOpen(true);
  };

  useEffect(() => {
    if (data?.length > 0) {
      setLoads(data);
    } else if (data?.length === 0) {
      setLoads([]);
    }
  }, [data]);

  useEffect(() => {
    const signal = createabort().abortCall.signal;
    dispatch(getLoads({ ...pagination, signal }));
    dispatch(getActiveNames(signal));
    dispatch(freightNames(signal));
    return () => {
      createabort().abortCall.abort();
    };
  }, []);

  // useEffect(() => {
  //   if (inputValue.length > 0) {
  //     stopInterval();
  //   }
  //   if (inputValue.length < 1) {
  //     startInterval();
  //   }
  // }, [inputValue]);

  return (
    <>
      <Box className='loads' sx={{ position: 'relative', overflow: 'hidden' }}>
        <Box className='loads-title'>
          <CustomBreadcrumbs
            itemOne={constants.Loads}
            itemTwo='Load Shipment'
            itemTwoState={view}
            setView={setView}
          />
          <CustomButton
            className='saveChanges'
            category='Add Loads'
            onClick={handleSelect}
          />
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px'
          }}
          className='search-loads'
        >
          <CustomSearch
            id='searchField'
            control={control}
            name='searchField'
            options={dynamicOptions}
            // placeholder={placeholderText[index]}
            placeholder='Search for ...'
            icon={<i className='custom-icon' />}
            variant='standard'
            inputValue={inputValue}
            handleInputChange={handleInputChange}
            onChanges={handleSearchColumnChange}
            handleSearchClick={handleSearch}
          />
        </Box>
        {view && (
          <CustomDataGrid
            loading={isLoading}
            type={'logistics'}
            rows={stackeholdernames}
            columns={columnsView}
          />
        )}
        {!view && (
          <CustomDataGrid
            rows={loads}
            columns={columns}
            loading={isLoading}
            onSortModelChange={handleSortModelChange}
            rowCount={count}
            type={'logistics'}
            pageNo={pageNo}
            pageSize={pageSize}
            paginationModel={{
              page: pageNo && count ? pageNo - 1 : 0,
              pageSize: pageSize ? pageSize : 5
            }}
            onPaginationModelChange={handlePagination}
          />
        )}
      </Box>
      {open && (
        <AddLoad
          open={open}
          setOpen={setOpen}
          roleType={type}
          setPageNo={setPageNo}
          setTablePayload={setTablePayload}
          setPageSize={setPageSize}
          filteredRow={filteredRow}
          stackeholdernames={stackeholdernames}
          isLoading={isLoading}
          setFilteredRow={setFilteredRow}
        />
      )}
      {isDelete && (
        <CustomDeletePopup
          open={isDelete}
          setOpen={setIsDelete}
          handleDelete={handleDelete}
          handleClose={handleClose}
          message={message}
          isLoading={deleteLoading}
        />
      )}

      {isActivate && (
        <CustomActivatePopup
          filteredRow={filteredRow}
          open={isActivate}
          setOpen={setIsActivate}
          handleDeactivate={handleDeactivate}
          isLoading={deactivateLoading}
        />
      )}
      {viewFreight && (
        <CustomDialogList
          open={viewFreight}
          handleViewClose={handleViewClose}
          title1='Freight Numbers'
          onClose={handleCloseDialog}
          item1={Freightdata}
          type={'geofence'}
        />
      )}

      {isShowMap && (
        <CustomDialog
          view={isShowMap}
          tripsData={Polyline}
          locations={Waypoints}
          isShowMap={isShowMap}
          handleViewClose={() => {
            dispatch(updateIsShowMap(false));
          }}
          maplegend={false}
        />
      )}
    </>
  );
};

export default Loads;
